import { res_modifiers_config } from "../../helper/res_modifiers_config";

// Define the API URLs for different environments
// dev=http://54.179.160.96:8037
// uat=http://54.179.160.96:8038

// export const API_URLs = {
//   production: "http://marigold-dev.innovixdigital.com",
//   development: "http://marigold-dev.innovixdigital.com",
// };

export const API_URLs = {
  production: "http://uat-testing-marigold.innovixerp.com",
  development: "http://uat-testing-marigold.innovixerp.com",
};

export const endpoints = Object.freeze({
  auth: {
    signIn: {
      method: "get",
      endpoint: "api/auth/{:userid}/token",
      res_modifier: res_modifiers_config.getAccessToken,
      token: "optional", // require, optional
      // expire_in: 10
    },
    login: {
      method: "get",
      endpoint: "api/auth/token",
    },
    logout: {
      method: "delete",
      endpoint: "api/auth/token",
      token: "require",
    },
    changePassword: {
      method: "post",
      endpoint: "api/password/change",
      token: "require",
    },
  },
  user: {
    profile: {
      method: "get",
      endpoint: "api/user",
      token: "require",
    },
    getUserList: {
      method: "get",
      endpoint: "api/user/list",
      token: "require",
    },
    getUserGroup: {
      method: "get",
      endpoint: "api/user/group",
      token: "require",
    },
  },
  home: {
    getHome: {
      method: "get",
      endpoint: "api/home",
      token: "require",
    },
  },
  customer: {
    customerList: {
      method: "get",
      endpoint: "api/customer",
      token: "require",
    },
    customerDetail: {
      method: "get",
      endpoint: "api/customer/{:id}",
      token: "require",
    },
    createCustomer: {
      method: "post",
      endpoint: "api/create/customer",
      token: "require",
    },
    deleteCustomer: {
      method: "delete",
      endpoint: "api/customer/{:id}",
      token: "require",
    },
    updateCustomer: {
      method: "put",
      endpoint: "api/customer/{:id}",
      token: "require",
    },
  },
  saleOrder: {
    saleOrderList: {
      method: "get",
      endpoint: "api/saleorder",
      token: "require",
    },
    deleteSaleOrder: {
      method: "delete",
      endpoint: "api/saleorder/{:saleOrderId}",
      token: "require",
    },
    getSaleOrderDetail: {
      method: "get",
      endpoint: "api/saleorder",
      token: "require",
    },
    deleteSaleOrderLine: {
      method: "delete",
      endpoint: "api/saleorder/{:saleOrderId}/orderline/{:saleOrderLineId}",
      token: "require",
    },
  },
  others: {
    otherIn: {
      method: "get",
      endpoint: "api/auth/token",
    },
    getAllLocations: {
      method: "get",
      endpoint: "api/locations/mm",
    },
    faceBookSignIn: {
      method: "get",
      endpoint: "api/auth/facebook",
    },
  },
  liveSale: {
    roomList: {
      method: "get",
      endpoint: "api/livesale/room",
      token: "require",
    },
    liveSaleSessionList: {
      method: "get",
      endpoint: "api/livesale/session",
      token: "require",
    },
    liveSaleSessionDetail: {
      method: "get",
      endpoint: "api/livesale/session/{:sessionId}",
      token: "require",
    },
    startLiveSaleSession: {
      method: "put",
      endpoint: "api/livesale/session/{:sessionId}/start",
      token: "require",
    },
    stopLiveSaleSession: {
      method: "put",
      endpoint: "api/livesale/session/{:sessionId}/end",
      token: "require",
    },
    createLiveSale: {
      method: "post",
      endpoint: "api/livesale",
      token: "require",
    },
    deleteLiveSale: {
      method: "delete",
      endpoint: "api/livesale/{:id}",
      token: "require",
    },
  },
  product: {
    detail: {
      method: "get",
      endpoint: "api/product/{:productID}",
      token: "require",
    },
    type: {
      method: "get",
      endpoint: "api/product_type",
      token: "require",
    },
    getAllProduct: {
      method: "get",
      endpoint: "api/product",
      token: "require",
    },
    getAllCategory: {
      method: "get",
      endpoint: "api/product/category",
      token: "require",
    },
  },
  transfer: {
    getWarehouseList: {
      method: "get",
      endpoint: "api/warehouse/location",
      token: "require",
    },
    sendRequest: {
      method: "post",
      endpoint: "api/transfer/request",
      token: "require",
    },
    getProductRequestTransfer: {
      method: "get",
      endpoint: "api/product/request",
      token: "require",
    },
    cancelRequest: {
      method: "put",
      endpoint: "api/transfer/{:id}/cancel",
      token: "require",
    },
    productRequestDetail: {
      method: "get",
      endpoint: "api/product/request/{:id}",
      token: "require",
    },
  },
  report: {
    saleReport: {
      method: "get",
      endpoint: "api/sale/report",
      token: "require",
    },
    ProductandCategory: {
      method: "get",
      endpoint: "api/category/sales/report",
      token: "require",
    },
    SaleTeam: {
      method: "get",
      endpoint: "api/sale/teams",
      token: "require",
    },
    TeamReport: {
      method: "get",
      endpoint: "api/saleteam/{:id}/report",
      token: "require",
    },
  },
  persistSlice: {},
});
